import {Grid} from '@yandex-delivery/blocks'
import type {PropsWithChildren, ReactElement, ReactNode} from 'react'

import * as classes from './Body.classes'

type Props = PropsWithChildren<{
  className?: string
  lead?: ReactNode
  tail: ReactNode
}>

export function Body({lead, tail, children, className}: Props): ReactElement {
  return (
    <Grid className={className} wrap="nowrap" container>
      {lead && (
        <Grid className={classes.lead} item>
          {lead}
        </Grid>
      )}
      {children && (
        <Grid item xs>
          {children}
        </Grid>
      )}
      <Grid className={classes.tail} item>
        {tail}
      </Grid>
    </Grid>
  )
}
